import axios from 'axios';
import * as api from "../server/api";

export const GET_SERVICES_REQUEST = "AR/GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "AR/GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "AR/GET_SERVICES_FAILURE";

const initialState = {
  loading: false,
  error: false,
  data: [],
};

export default function reducersServizi(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICES_REQUEST:
      return { ...state, loading: true };
    case GET_SERVICES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_SERVICES_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}

export const getAllServices = () => {
  return async (dispatch) => {
    dispatch({ type: GET_SERVICES_REQUEST });
    try {
      const { url, method, data } = api.getAllServices();
      const results = await axios({
        url,
        method,
        data,
      });

      // console.log(results);

      if (results.status === 200) {
        const { servizios } = results.data.data;

        const services = servizios.map(serv => {
          return {
            name: serv.nome,
            target: serv.identificativo
          }
        })
        
        dispatch({
          type: GET_SERVICES_SUCCESS,
          payload: services,
        });
      } else {
        dispatch({
          type: GET_SERVICES_FAILURE,
          error: results.status,
        });
      }
    } catch (e) {
      console.log("error", e);
      console.log("error", e.response);
      dispatch({
        type: GET_SERVICES_FAILURE,
        error: e,
      });
    }
  };
};